import { observable } from 'mobx';
import { IContentOrganizer } from '../../../interfaces/IContentOrganizerCreate';
import { IInstance } from '../../../interfaces/IInstance';

export class ContentOrganizerAdminStore {

  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;
  @observable public instance: IInstance;
  @observable public selectedInstance: IContentOrganizer;
  @observable public isMobile: boolean;
}